module.exports = __webpack_public_path__ + "img/success_7.df93bb0d.gif";